const styles = {
  location: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    height: '13px',
    marginRight: '4px',
  },
  iconSvg: {
    width: 'auto',
    height: '100%',
    '& path': {
      fill: 'currentColor',
    },
  },
  iconSvgStroke: {
    width: 'auto',
    height: '100%',
    '& path': {
      stroke: 'currentColor',
    },
  },
};

export default styles;
